import(/* webpackMode: "eager", webpackExports: ["GameEventBridgeProvider"] */ "/app/app/components/game-player/context/message-event-context.tsx");
